import { styled } from '@mui/material/styles';
import MuiCardMedia from '@mui/material/CardMedia';

export const CardMedia = styled(MuiCardMedia)(() => ({
  borderRadius: '100%',
  width: '62px',
  height: '62px'
})) as typeof MuiCardMedia;
